import promotionRepo from '../services/promotionCodes';

export const PROMOTIONS_REFRESHED           = 'PROMOTIONS_REFRESHED';
export const HIDE_NEW_PROMO_CODE_OVERLAY    = 'HIDE_NEW_PROMO_CODE_OVERLAY';
export const SHOW_NEW_PROMO_CODE_OVERLAY    = 'SHOW_NEW_PROMO_CODE_OVERLAY';
export const SHOW_DELETE_PROMO_CODE_OVERLAY = 'SHOW_DELETE_PROMO_CODE_OVERLAY';
export const HIDE_DELETE_PROMO_CODE_OVERLAY = 'HIDE_DELETE_PROMO_CODE_OVERLAY';
export const SHOW_EDIT_PROMO_CODE_OVERLAY   = 'SHOW_EDIT_PROMO_CODE_OVERLAY';
export const HIDE_EDIT_PROMO_CODE_OVERLAY   = 'HIDE_EDIT_PROMO_CODE_OVERLAY';

export function deletePromotion(promotionId) {

    return (dispatch) => {

        function deleteSuccess() {

            dispatch(hideDeletePromoOverlay());
            dispatch(refreshPromotions());
        }

        promotionRepo.remove(promotionId)
            .then(deleteSuccess);
    };
}

export function hideEditPromoCodeOverlay() {

    return {
        type: HIDE_EDIT_PROMO_CODE_OVERLAY
    }
}

export function hideDeletePromoOverlay() {

    return {
        type: HIDE_DELETE_PROMO_CODE_OVERLAY
    };
}

export function showEditPromoOverlay(promotion) {

    return {
        type: SHOW_EDIT_PROMO_CODE_OVERLAY,
        promotion
    };
}

export function showDeletePromoOverlay(promotion) {

    return {
        type: SHOW_DELETE_PROMO_CODE_OVERLAY,
        promotion
    };
}

export function showNewPromoCodeOverlay() {

    return {
        type: SHOW_NEW_PROMO_CODE_OVERLAY
    };
}

export function hideNewPromoCodeOverlay() {

    return {
        type: HIDE_NEW_PROMO_CODE_OVERLAY
    };
}

export function refreshPromotions() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(promotionsRefreshed(response.data.data));
        }

        promotionRepo.getAll()
            .then(getSuccess);
    };
}

export function promotionsRefreshed(promotions) {

    return {
        type: PROMOTIONS_REFRESHED,
        promotions
    };
}


// WEBPACK FOOTER //
// ./actions/promotionList.js